import React from 'react'
import { useValues } from 'kea'

import LocationType from '../sections/location-type'
import Location from '../sections/location'
import filtersLogic from '~/scenes/search/filters-page/logic'
import TeacherLocation from '~/scenes/search/filters-page/filters/sections/teacher-location'
import BottomActions from './bottom-actions'
import PropTypes from 'prop-types'

export default function LocationFilters ({ fullScreenFiltersPage }) {
  const {
    unsavedFilter: { location_types: locationTypes },
    showSearchBtnOnClearAll
  } = useValues(filtersLogic)

  return (
    <div className='all-filters-content'>
      <LocationType />
      {locationTypes ? (
        locationTypes !== 'webcam' ? (
          <Location fullScreenFiltersPage={fullScreenFiltersPage} locationFilterComponent />
        ) : (
          <TeacherLocation />
        )
      ) : null}
      {fullScreenFiltersPage && (showSearchBtnOnClearAll || locationTypes) && (
        <BottomActions locationBottomActionsStyles />
      )}
    </div>
  )
}

LocationFilters.propTypes = {
  fullScreenFiltersPage: PropTypes.bool
}
